module.exports = __webpack_public_path__ + "img/hong_kong.f5a64d4d.png";